import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import WhatsAppAddon from "./WhatsAppAddon";
import AllowedCountriesAddon from "./AllowedCountriesAddon";
import LiveChatWidgetAddon from "./LiveChatWidgetAddon";
import Background from "../sale-page/page-blocks/block-parts/models/Background";
import Theme from "./addons/parts/Theme";
export default class Addons {
  constructor() {
    _defineProperty(this, "background", {
      fieldName: 'background',
      model: Background,
      content: null
    });
    _defineProperty(this, "theme", {
      fieldName: 'theme',
      model: Theme,
      content: null
    });
    _defineProperty(this, "NavBar", {
      fieldName: 'show_sale_page_navbar',
      content: true
    });
    _defineProperty(this, "footer", {
      fieldName: 'show_sale_page_footer',
      content: true
    });
    _defineProperty(this, "StickyBuyButton", {
      fieldName: 'sticky_buy_button',
      content: true
    });
    _defineProperty(this, "VisibleButtonPrice", {
      fieldName: 'visible_button_price',
      content: false
    });
    _defineProperty(this, "disabledSelectionAndContextMenu", {
      fieldName: 'disable_selection_and_context_menu',
      content: false
    });
    _defineProperty(this, "includeInHomeAndProductsPage", {
      fieldName: 'include_in_home_and_product_page',
      content: true
    });
    _defineProperty(this, "liveChatWidget", {
      fieldName: 'live_chat_widget',
      model: LiveChatWidgetAddon,
      content: null
    });
    /*TrustBadgesVisibility = {
        fieldName: 'trust_badges_visibility',
        content: true
    }
    AboutUsVisibility = {
        fieldName: 'about_us_visibility',
        content: true
    }
    AfterSaleFaqVisibility = {
        fieldName: 'after_sale_faq_visibility',
        content: true
    }*/
    _defineProperty(this, "WhatsAppButton", {
      fieldName: 'whatsapp_button',
      model: WhatsAppAddon,
      content: null
    });
    _defineProperty(this, "AllowedCountries", {
      fieldName: 'allowed_countries',
      model: AllowedCountriesAddon,
      content: []
    });
  }
  /*isTrustBadgeVisible() {
      return this.TrustBadgesVisibility.content
  }
   isAboutUsVisible() {
      return this.AboutUsVisibility.content
  }
   isAfterSaleFaqVisible() {
      return this.AfterSaleFaqVisibility.content
  }*/

  getWhatsApp() {
    return this.WhatsAppButton.content;
  }
  hasWhatsApp() {
    let whatsApp = this.WhatsAppButton.content;
    return whatsApp instanceof WhatsAppAddon ? whatsApp.isActive() : false;
  }
  getTheme() {
    return this.theme.content;
  }
}